import React from 'react';
import clsx from 'clsx';

interface ModalActionsProps {
  children: React.ReactNode;
  className?: string;
  spacing?: 'tight' | 'normal' | 'loose';
}

const spacingClasses = {
  tight: 'gap-2',
  normal: 'gap-3',
  loose: 'gap-4',
};

export function ModalActions({
  children,
  className,
  spacing = 'normal',
}: ModalActionsProps) {
  return (
    <div className={clsx('flex', spacingClasses[spacing], className)}>{children}</div>
  );
}
